import StudioRoutes from '@/utils/routes';
import {
  VIDEO_TEMPLATES,
  AI_TOOLS,
  MAKE_WITH_CHAT,
  CREATIONS,
  PUBLISH,
  INTEGRATIONS,
  SETTINGS,
  LABS,
} from '@/constants/text';

export interface NavItemConfig {
  href: string;
  icon?: React.ComponentType;
  title: string;
}

export const MAIN_NAVIGATION_ITEMS: NavItemConfig[] = [
  {
    href: StudioRoutes.newVideo(),
    title: VIDEO_TEMPLATES,
  },
  {
    href: StudioRoutes.aiTools(),
    title: AI_TOOLS,
  },
  {
    href: StudioRoutes.makeWithChat(),
    title: MAKE_WITH_CHAT,
  },
  {
    href: StudioRoutes.labs(),
    title: LABS,
  },
  /*
    19.03.2025: Hiding for BFS.
    TODO: If not needed later, remove it.
  */
  // {
  //   href: StudioRoutes.avatars(),
  //   title: INFLUENCERS,
  // },
  {
    href: StudioRoutes.library(),
    title: CREATIONS,
  },
  {
    href: StudioRoutes.publish(),
    title: PUBLISH,
  },
  {
    href: StudioRoutes.integrations(),
    title: INTEGRATIONS,
  },
  {
    href: StudioRoutes.settings(),
    title: SETTINGS,
  },
];
